/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import CallPassCharts from './CallPassCharts'; // Import the new chart component
import formatDateTimeToPST from '../../PSTDateConvert';
import Pagination from 'react-js-pagination';
import Modal from 'react-modal';
import Select from 'react-select';
 
const CallPassDisplayIdentityDetails = () => {
    const location = useLocation();
    // 'initialFilters' holds filter values passed from another page
    const { initialFilters } = location.state || {};

    const [name, setName] = useState('');
    const [timeZone, seTimeZone] = useState('');
    const [token, setToken] = useState('');
    const [cid, setCid] = useState('');
    const [expire, setExpire] = useState('');  
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [callPassDisplayIdentitiesAccess, setCallPassDisplayIdentitiesAccess] = useState(false);
    const [userCallPassDisplayIdentitiesAccess, setUserCallPassDisplayIdentitiesAccess] = useState(false);
    const [canEditIdentities, setCanEditIdentities] = useState(false);
    const [loadingCount, setLoadingCount] = useState(0);
    const [isSuccess, setIsSuccess] = useState(false);
    const [company, setCompany] = useState([]);
    const [tnNumbersAll, setTnNumbersAll] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    // Date and Time range filters
    const getYesterday = () => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return yesterday;
    };
    // Initialize filter states:
    // 1. From 'initialFilters' if present (e.g., coming from Details page).
    // 2. Else, use default values.
    const [selectedCompany, setSelectedCompany] = useState(initialFilters?.selectedCompany || "");
    const [selectedNumber, setSelectedNumber] = useState("");

    // Other filters
    const [selectedEntity, setSelectedEntity] = useState(initialFilters?.selectedEntity || "");
    const [selectedDisplayIdentity, setSelectedDisplayIdentity] = useState(initialFilters?.selectedDisplayIdentity || "");
    const [selectedOrigationNumber, setSelectedOrigationNumber] = useState(initialFilters?.selectedOrigationNumber || "");
    

    // Options for filters (to be fetched from API)
    const [entityOptions, setEntityOptions] = useState([]);
    const [displayIdentityOptions, setDisplayIdentityOptions] = useState([]);
    const [origationNumberOptions, setOrigationNumberOptions] = useState([]);

    // Summary Data
    const [summaryData, setSummaryData] = useState([]);

    // State for chart drilldown
    const [selectedDisplayIdentityForDrilldown, setSelectedDisplayIdentityForDrilldown] = useState(null);
    const isInitialPageLoadForAutoApply = React.useRef(true); // Ref to track initial auto-apply

    const [showModal, setShowModal] = useState(false);
    const [tnNumbers, setTnNumbers] = useState([])

    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
        getUserCompany();
    }, []);

    useEffect(() => {
        if(cid){
            checkPageAccess();
        }
    }, [cid]);

    const incrementLoading = () => setLoadingCount((prev) => prev + 1);
    const decrementLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        setPopupOpen(loadingCount > 0);
    }, [loadingCount]);

    useEffect(() => {
        if(role >= 3 && cid){
            setSelectedCompany(cid);
        }
    }, [cid, role]);

    // Effect to auto-apply filters on initial load if selectedCompany is present from initialFilters
    useEffect(() => {
        if (
            
            isInitialPageLoadForAutoApply.current &&
            (role >= 3 || (role <= 2 && initialFilters?.selectedCompany)) && // Check if a company was passed initially
            selectedCompany && // Ensure state is also updated (should match initialFilters)
            token &&
            cid &&
            callPassDisplayIdentitiesAccess &&
            userCallPassDisplayIdentitiesAccess
        ) {
            console.log("Initial load with selectedCompany, applying filters automatically for Summary page.");
            handleApplyFilters();
            isInitialPageLoadForAutoApply.current = false; // Prevent re-triggering
        }
    }, [
        initialFilters?.selectedCompany,
        selectedCompany,
        token,
        cid,
        role,
        callPassDisplayIdentitiesAccess,
        userCallPassDisplayIdentitiesAccess,
    ]);

    useEffect(() => {
        if (selectedCompany) {
            fetchDisplayIdentityTnNumbers(page, selectedCompany, selectedNumber);
        }
    },[page, selectedCompany, selectedNumber])


    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded);
            setName(decoded.name);
            seTimeZone(decoded.timezone);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
        } catch (error) {
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }
    
    const checkPageAccess = async () => {
        try {
            incrementLoading();
            // Fetch all required data            
            const customerDigitMappingResponse = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const userAccessResponse = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            const callPassDisplayIdentitiesSwitch = customerDigitMappingResponse.data.call_pass_display_identities_switch;
            const userCallPassDisplayIdentitiesSwitch = userAccessResponse.data.user_call_pass_display_identities_switch;
            decrementLoading();
            setAccess(userAccessResponse.data.results);
            // Conditional check for access
            if (
                callPassDisplayIdentitiesSwitch >= 1 &&
                userCallPassDisplayIdentitiesSwitch >= 1
            ) {
                setUserCallPassDisplayIdentitiesAccess(true);
                setCallPassDisplayIdentitiesAccess(true);
                setCanEditIdentities(parseInt(callPassDisplayIdentitiesSwitch) >= 2 && parseInt(userCallPassDisplayIdentitiesSwitch) >= 2);
            } else {
                navigate('/dashboard');
            }
        } catch (error) {
            console.error("Error checking page access:", error);
            navigate('/dashboard'); // Redirect in case of any error
        }
    };

    const getUserCompany = async () => {
        
        const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const company = response.data.filter(item => item.id !== 1);
        // company.shift();
        // console.log(response.data);
        setCompany(company);
    }

    const formatDateToYYYYMMDD = (date) => {
        if (!date) return ''; // Handle null or undefined dates
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }

    const fetchDisplayIdentityTnNumbers = async (page, company, number) => {
        incrementLoading();
        try {
            // TODO: Replace with actual API endpoint and payload
            const response = await axiosJWT.get(`${baseUrl}/call-pass-display-identity-details`, {
                params: { 
                    page: page,
                    limit: 20,
                    company: company,
                    displayIdentity: selectedDisplayIdentity,
                    entity: selectedEntity,
                    tnNumber: number
                },
                headers: { Authorization: `Bearer ${token}` }
            });
            setSummaryData(response.data.summary || []);
            setTnNumbersAll(response.data.tnNumbers || []);
            setTotalItem(response.data.totalItem);
            setSelectedDisplayIdentityForDrilldown(null);
            console.log("Fetched summary data based on all filters.");
        } catch (error) {
            console.error("Error fetching summary data:", error);
            // Handle error
        } finally {
            decrementLoading();
        }
    };

    const openModal = async () => {
        incrementLoading();
        try {
            const response = await axiosJWT.get(`${baseUrl}/get-call-passed-enabled-numbers`, {
                params: { 
                    cid: selectedCompany,
                    displayIdentity: selectedDisplayIdentity,
                    entity: selectedEntity
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setTnNumbers(response.data);
            setShowModal(true);
        } catch (error) {
            console.error("Error fetching enabled numbers:", error);
        } finally {
            decrementLoading();
        }
    };

    const closeModal = () => {
        setTnNumbers([])
        setShowModal(false);
    }

    const handleApplyFilters = () => {
        // Data fetching is triggered by useEffect dependencies,
        // but you might want an explicit button to signify user action.        
        fetchDisplayIdentityTnNumbers(1, selectedCompany, selectedNumber); // Or let useEffect handle it
       
    };

    const handleClearFilters = () => {
        setSelectedNumber('');
        setSelectedOrigationNumber("");
        if (role > 2) {
            setSelectedCompany(cid);
        }
    };

    const removeTn = async (e, item) => { 
        e.preventDefault();
        if(window.confirm(`Are you sure you want to remove this Tn?`)){
            try {
                incrementLoading();
                const response = await axios.post(`${baseUrl}/call-pass-remove-dirid-tn`, {
                    id: item.id,
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                decrementLoading();

                if (response.data.status) {
                    alert('TN record removed successfully.');
                    fetchDisplayIdentityTnNumbers(page, selectedCompany, selectedNumber);
                } else {
                    alert(`Failed to remove TN: ${response.data.msg}`);
                }

            } catch (error) {
                decrementLoading();
                if (error.response) {
                    setIsSuccess(false);
                    // setMsg(error.response.data.msg);
                }
            }
        }
    }

    const isDefaultDate = (date, defaultDateFunc) => {
        const defaultDate = defaultDateFunc();
        return date.getFullYear() === defaultDate.getFullYear() &&
               date.getMonth() === defaultDate.getMonth() &&
               date.getDate() === defaultDate.getDate();
    };
 
    const showClearButton = selectedNumber !== "";  
    
 
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            seTimeZone(decoded.timezone);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const gotoDisplayIdentitiesScreen = (e) => {
        e.preventDefault();
        const navigationState = {
            initialFilters: { // Current filter values from Summary page
                selectedCompany,
            }
        }
        navigate("/call-pass-display-identities", { state: navigationState });
    }
 
    
 
    return (
        <div className="panelbox">
           <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-4">
                            <div className="left-title">
                                <h1>Call Pass Display Identity Details</h1>
                            </div>
                        </div>
                        <div className="col-8 inventory-btn">
                            <div className="addnew-button">
                                {canEditIdentities && <a href="#" style={{marginLeft: '10px',paddingBottom: '15px'}} onClick={openModal}>Add Tn</a>}
                                {/* <Link to="/dashboard"><span>&larr;</span>Dashboard</Link> */}
                                {/* <div className="addnew-button"> */}
                                    <a href="#" onClick={(e) => gotoDisplayIdentitiesScreen(e)}><span>&larr;</span>Back</a>
                                    {/* <Link to="/cas-management"> Back</Link> */}
                                {/* </div> */}
                            </div>
                        </div>                        
                    </div>

                    {/* Filter Section */}
                    <div className="common-white-shadow-background setting-section">
                        <div className="row filter-section align-items-end"> {/* All filters and buttons in this single row, align items to bottom */}
                            {role <=2 &&<div className="col-md-2">
                                <label>Company:</label>
                                <select disabled value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)} className="form-control">
                                <option value="" >Company</option>
                                    {company.map(option => (
                                        <option key={option.id} value={option.id}>{option.cname}</option>
                                    ))}
                                </select>
                            </div>}
                            <div className='col-md-2'>
                                <label>Number:</label>
                                <Select
                                    classNamePrefix="select"
                                    name="number"
                                    placeholder="Select Number"
                                    className='search-select enrms-summary-tags'
                                    onChange={(selectedOption)=>{
                                        setSelectedNumber(selectedOption.value)
                                    }}
                                    value={
                                        selectedNumber
                                        ? { value: selectedNumber, label: selectedNumber }
                                        : null   // 👈 Important: show placeholder when no selection
                                    }
                                    options={ tnNumbersAll?.map(number => ({
                                        value: number,
                                        label: number                                               
                                    }))}
                                />
                            </div>
                            <div className="col-md-2" style={{marginTop:"23px"}}> 
                                 <div style={{ display: 'flex', justifyContent: 'flex-start', paddingBottom: '10px' }}> 
                                 {/* <button
                                         onClick={handleApplyFilters}
                                         className="search-btn"
                                         style={{
                                             width: 'auto', // Override .search-btn width: max-content (if needed for consistency)
                                             display: 'inline-block', // Override .search-btn display: block
                                             marginLeft: '0', // Override .search-btn margin-left: AUTO
                                             marginRight: '10px' // Ensure no extra right margin
                                         }}
                                     >
                                         Apply
                                     </button> */}
                                     {showClearButton && (
                                         <button
                                             onClick={handleClearFilters}
                                             className="search-btn clear-btn"
                                             style={{
                                                 marginRight: '10px',
                                                 width: 'auto', // Override .clear-btn fixed width
                                                 display: 'inline-block', // Override .search-btn display: block
                                                 marginLeft: '0' // Override .search-btn margin-left: AUTO
                                             }}
                                         >
                                             Clear
                                         </button>
                                     )}
                                     
                                 </div>
                             </div>
                        </div>
                        
                    </div>

                    {summaryData.length > 0 && <div className="common-white-shadow-background setting-section">
                        <div className="row">
                        <div className=" setting-section haft-whitebox">
                            <div className="search-result-section">
                                <h3></h3>
                                {/* <div className="export-btn newrow"><a className="newrow" href="#">Export</a></div> */}
                            </div>
                                <table className="tablebox search-result-table">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>TN</th>
                                            <th>Entity Name</th>
                                            <th>Display Identity</th>
                                            <th>Logo Status</th>
                                            <th>Logo</th>
                                            <th>Call Reason</th>
                                            <th>Created by</th>
                                            <th>Created Date ({timeZone})</th>
                                            {canEditIdentities && <th>Action</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {summaryData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item?.id}</td>
                                                <td>{item?.TN}</td>
                                                <td>{item?.entity_name}</td>
                                                <td>{item?.display_name}</td>
                                                <td>{item?.logo}</td>
                                                <td>
                                                    {item.logo_url && (
                                                        <img
                                                        src={item.logo_url}
                                                        alt="logo"
                                                        style={{ width: 24, height: 24 }}
                                                        />
                                                    )}
                                                </td>
                                                <td>{item?.call_reason}</td>
                                                <td>{item?.created_by}</td>
                                                <td>{formatDateTimeToPST(item?.created_date, timeZone, role)}</td>
                                                {canEditIdentities && <td><a onClick={(e) => removeTn(e, item)}><img src={`${process.env.PUBLIC_URL}/images/bx-x-circle.png`} alt="Active" title="Remove TN" /></a></td>}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                
                                {totalItem > 20 && (<Pagination
                                    activePage={page}
                                    itemsCountPerPage={20}
                                    totalItemsCount={totalItem}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange.bind(this)}
                                />)}
                            </div>
                        </div>
                    </div>}
                   {showModal && <PopupAddTn tnNumbers={tnNumbers} onClose={closeModal} eid={selectedEntity} dirid={selectedDisplayIdentity} token={token} onAddSuccess={() => fetchDisplayIdentityTnNumbers(page, selectedCompany, selectedNumber)} />}
                </div>
            </div>            
        </div>
    )
}

const PopupAddTn = ({ tnNumbers, onClose, eid, dirid, token, onAddSuccess }) => {
    const [selectedTnNumber, setSelectedTnNumber] = useState('');
    const [error, setError] = useState('');

    const handleTnNumberChange = (e) => {
        setSelectedTnNumber(e.target.value);
        if (e.target.value) {
            setError('');
        }
    }

    const handleAdd = async () => {
        if (!selectedTnNumber) {
            setError('Please select a number to add.');
            return;
        }
        setError('');

        try {
            const response = await axios.post(`${baseUrl}/add-display-identity-tn`, {
                tn: selectedTnNumber,
                eid: eid,
                dirid: dirid,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.status) {
                alert('TN record added successfully.');
                onAddSuccess();
                onClose();
            } else {
                // Use the more specific 'error' field if available, otherwise fallback to 'msg'
                const errorMessage = response.data.error || response.data.msg || "An unknown error occurred.";
                alert(`Failed to add TN: ${errorMessage}`);
            }
        } catch (error) {
            console.error("Error adding TN:", error.response ? error.response.data : error);
            // Extract the most specific error message from the backend response
            const errorMessage = error.response?.data?.error || error.response?.data?.msg || "An unexpected server error occurred.";
            alert(`Failed to add TN: ${errorMessage}`);
        }
    };

  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="policy">
            <label>Tn Numbers</label>
            <div className="switchbtn">
                <Select
                    classNamePrefix="select"
                    name="number"
                    placeholder={"Select Number"}
                    className='search-select enrms-summary-tags w-10'
                    onChange={(selectedOption)=>{
                        setSelectedTnNumber(selectedOption.value)
                        setError('')
                    }}
                    value={
                        selectedTnNumber
                        ? { value: selectedTnNumber, label: selectedTnNumber }
                        : null   // 👈 Important: show placeholder when no selection
                    }
                    options={ tnNumbers?.map(number => ({
                        value: number,
                        label: number                                               
                    }))}
                />
            </div>
        </div>
        {error && <p style={{ color: 'red', marginTop: '5px' }}>{error}</p>}
        <button className='apply-btn' onClick={handleAdd}>Add</button>
        <button className='apply-btn' onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};
 
export default CallPassDisplayIdentityDetails;